import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../../../axiosClient";

const BACKEND_URL = process.env.REACT_APP_LARAVEL_API;

export const getResumeList = createAsyncThunk(
  "resume/getResumeList",
  async ({ search, token }, thunkAPI) => {
    try {
      const res = await axios.get(
        `${BACKEND_URL}/resumeListApi?keyword=${search}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
      );
      return res.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Fetch failed");
    }
  }
);

export const getResumeDetails = createAsyncThunk(
  "resume/getResumeDetails",
  async (id, thunkAPI) => {
    try {
      const res = await axios.get(
        `${BACKEND_URL}/resumeDetailsApi/${id}`, {
        // headers: {
        //   Authorization: `Bearer ${token}`,
        // },
      }
      );
      return res.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Fetch failed");
    }
  }
);

export const deleteResume = createAsyncThunk(
  "resume/deleteResume",
  async ({ token, id }, thunkAPI) => {
    try {
      const res = await axios.delete(
        `${BACKEND_URL}/deleteResumeApi/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return { id, message: res.data.message || "Resume deleted successfully" };
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Delete failed");
    }
  }
);

export const addResume = createAsyncThunk(
  "resume/addResume",
  async ({ token, formData }, thunkAPI) => {
    try {
      const res = await axios.post(
        `${BACKEND_URL}/addResumeApi`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "API call failed");
    }
  }
);

export const addJobApplication = createAsyncThunk(
  "resume/addApplication",
  async ({ token, formData }, thunkAPI) => {
    try {
      const res = await axios.post(
        `${BACKEND_URL}/jobApplicationApi`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "API call failed");
    }
  }
);

export const editResume = createAsyncThunk(
  "resume/editResume",
  async ({ token, formData }, thunkAPI) => {
    try {
      const res = await axios.post(
        `${BACKEND_URL}/resumeUpdateApi`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "API call failed");
    }
  }
);

export const getSkillsByResumeCount = createAsyncThunk(
  "resume/skillsByResume",
  async (token, thunkAPI) => {
    try {
      const res = await axios.get(
        `${BACKEND_URL}/skillByResumeCount`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
      );
      return res.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Fetch failed");
    }
  }
);

export const getOwnApplyJobs = createAsyncThunk(
  "resume/getOwnApplyJobs",
  async ({ token, filters = {} }, thunkAPI) => {
    try {
      const res = await axios.get(
        `${BACKEND_URL}/applyJobSee`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          keyword: filters.keyword || "",
          status: filters.status || "",
          date: filters.date || "",
        },
      }
      );
      return res.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Fetch failed");
    }
  }
);

export const getShiftJobOffers = createAsyncThunk(
  "resume/shiftJobOffers",
  async (token, thunkAPI) => {
    try {
      const res = await axios.get(
        `${BACKEND_URL}/offers`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
      );
      return res.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Fetch failed");
    }
  }
);

export const getShiftJobOfferDetils = createAsyncThunk(
  "resume/shiftJobOffersDetail",
  async ({id, token}, thunkAPI) => {
    try {
      const res = await axios.get(
        `${BACKEND_URL}/offers-detail/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
      );
      return res.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Fetch failed");
    }
  }
);

export const acceptShiftJobOffer = createAsyncThunk(
  "resume/acceptShiftJobOffer",
  async ({ offerId, token }, thunkAPI) => {
    try {
      const res = await axios.post(
        `${BACKEND_URL}/offers/${offerId}/accept`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return { offerId, data: res.data };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Accept failed"
      );
    }
  }
);

export const declineShiftJobOffer = createAsyncThunk(
  "resume/declineShiftJobOffer",
  async ({ offerId, token }, thunkAPI) => {
    try {
      const res = await axios.post(
        `${BACKEND_URL}/offers/${offerId}/decline`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return { offerId, data: res.data };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Decline failed"
      );
    }
  }
);

export const getShiftRequestAccesptJobs = createAsyncThunk(
  "resume/shiftRequestAcceptJobs",
  async (token, thunkAPI) => {
    try {
      const res = await axios.get(
        `${BACKEND_URL}/shiftRequestEmpList`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
      );
      return res.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Fetch failed");
    }
  }
);

export const logShiftAction = createAsyncThunk(
  "resume/logShiftAction",
  async ({ token, payload }, thunkAPI) => {
    try {
      const res = await axios.post(
        `${BACKEND_URL}/shift_request_logs`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Log failed"
      );
    }
  }
);

export const getShiftRequestIdLogs = createAsyncThunk(
  "resume/shiftRequestEmpLog",
  async (payload, thunkAPI) => {
    console.log('PAYLOAD', payload);
    try {
      const { id, shift_request_id, worker_id, token } = payload;

      let res;

      // CASE 1: id in URL
      if (id) {
        res = await axios.get(
          `${BACKEND_URL}/shiftRequestEmpLog/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }
      // CASE 2: params in body / query
      else {
        res = await axios.get(
          `${BACKEND_URL}/shiftRequestEmpLog?shift_request_id=${shift_request_id}&worker_id=${worker_id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }

      return res.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Request failed"
      );
    }
  }
);



const workerResumeSlice = createSlice({
  name: "workerResume",
  initialState: {
    resumeData: [],
    resumeDetails: [],
    skillsByResume: [],
    ownApplyJobs: [],
    jobApplications: [],
    shiftJobOffers: [],
    shiftJobOfferDetail: {},
    shiftRequestAcceptJobs: [],
    loading: false,
    error: null,
    actionLoading: false,
    actionError: null,
    lastShiftLog: null,
    shiftLogsByAssignId: {},
    loadingShiftId: null,
    shiftRequstIdLogs: [],
  },
  extraReducers: (builder) => {
    builder
      .addCase(getResumeList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getResumeList.fulfilled, (state, action) => {
        state.loading = false;
        state.resumeData = action.payload;
      })
      .addCase(getResumeList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getResumeDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getResumeDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.resumeDetails = action.payload;
      })
      .addCase(getResumeDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteResume.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteResume.fulfilled, (state, action) => {
        state.loading = false;
        state.resumeData = state.resumeData.filter(resume => resume.id !== action.payload.id);
        state.message = action.payload.message;
      })
      .addCase(deleteResume.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addResume.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addResume.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload?.message || "Resume created successfully";
      })
      .addCase(addResume.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      })
      .addCase(editResume.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editResume.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload?.message || "Resume updated successfully";
      })
      .addCase(editResume.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      })
      .addCase(getSkillsByResumeCount.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSkillsByResumeCount.fulfilled, (state, action) => {
        state.loading = false;
        state.skillsByResume = action.payload;
      })
      .addCase(getSkillsByResumeCount.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addJobApplication.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addJobApplication.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload?.message || "Job Applied successfully";
      })
      .addCase(addJobApplication.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      })
      .addCase(getOwnApplyJobs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getOwnApplyJobs.fulfilled, (state, action) => {
        // console.log("PAYLOAD:", action.payload);
        state.loading = false;
        state.ownApplyJobs = action.payload;
      })
      .addCase(getOwnApplyJobs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getShiftJobOffers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getShiftJobOffers.fulfilled, (state, action) => {
        state.loading = false;
        state.shiftJobOffers = action.payload.shift_request_assign;
      })
      .addCase(getShiftJobOffers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getShiftJobOfferDetils.pending, (state) => {
        state.loading = true;
      })
      .addCase(getShiftJobOfferDetils.fulfilled, (state, action) => {
        state.loading = false;
        state.shiftJobOfferDetail = action.payload.shift_request_detail;
      })
      .addCase(getShiftJobOfferDetils.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(acceptShiftJobOffer.pending, (state) => {
        state.loading = true;
      })
      .addCase(acceptShiftJobOffer.fulfilled, (state, action) => {
        state.loading = false;
        state.shiftJobOffers = state.shiftJobOffers.filter(
          (offer) => offer.id !== action.payload.offerId
        );
      })
      .addCase(acceptShiftJobOffer.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(declineShiftJobOffer.pending, (state) => {
        state.loading = true;
      })
      .addCase(declineShiftJobOffer.fulfilled, (state, action) => {
        state.loading = false;
        state.shiftJobOffers = state.shiftJobOffers.filter(
          (offer) => offer.id !== action.payload.offerId
        );
      })
      .addCase(declineShiftJobOffer.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getShiftRequestAccesptJobs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getShiftRequestAccesptJobs.fulfilled, (state, action) => {
        state.loading = false;
        state.shiftRequestAcceptJobs = action.payload.shift_request_emp;
      })
      .addCase(getShiftRequestAccesptJobs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(logShiftAction.pending, (state, action) => {
        state.loadingShiftId = action.meta.arg.payload.shift_req_assign_id;
      })
      .addCase(logShiftAction.fulfilled, (state, action) => {
        state.loadingShiftId = null;

        const log = action.payload?.data?.shift_request_emp;
        if (!log) return;

        const assignId = log.shift_req_assign_id;

        const index = state.shiftRequestAcceptJobs.findIndex(
          (s) => s.id === assignId
        );

        if (index !== -1) {
          state.shiftRequestAcceptJobs[index] = {
            ...state.shiftRequestAcceptJobs[index],
            check_in_time: log.check_in_time,
            check_out_time: log.check_out_time,
            hours_worked: log.hours_worked,
          };
        }
      })


      .addCase(logShiftAction.rejected, (state) => {
        state.loadingShiftId = null;
      })
      .addCase(getShiftRequestIdLogs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getShiftRequestIdLogs.fulfilled, (state, action) => {
        state.loading = false;
        state.shiftRequstIdLogs = action.payload.shift_request_emp_log;
      })
      .addCase(getShiftRequestIdLogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default workerResumeSlice.reducer;